import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { loadingProgress, isLoading } from './System/LoadingManager';

@Component({
	selector: 'app-loading-progress',
	standalone: true,
	imports: [CommonModule],
	template: `
		<div *ngIf="showProgress" class="loading-overlay">
			<div class="loading-container">
				<div class="progress-bar-container">
					<div class="progress-bar" [style.width.%]="progress"></div>
				</div>
			</div>
		</div>
	`,
	styles: [`
		.loading-overlay {
			position: relative;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: #f7f8fA;
			display: flex;
			justify-content: center;
			align-items: center;
			z-index: 1000;
		}

		.loading-container {
			width: 50%;
			max-width: 500px;
		}

		.progress-bar-container {
			height: 6px;
			background-color: #e0e0e0;
			border-radius: 3px;
			overflow: hidden;
		}

		.progress-bar {
			height: 100%;
			background-color: #9370DB;
			transition: width 0.3s ease;
		}
	`]
})
export class LoadingProgressComponent implements OnInit, OnDestroy {
	progress: number = 0;
	showProgress: boolean = false;

	private subscriptions: Subscription = new Subscription();

	ngOnInit(): void {
		this.subscriptions.add(
			loadingProgress.subscribe(progress => {
				this.progress = progress;
			})
		);

		this.subscriptions.add(
			isLoading.subscribe(loading => {
				this.showProgress = loading;
			})
		);
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
